import {useState, useEffect} from 'react';
import {getLocalStorageItem, setLocalStorageItem} from '../utils/localStorage';

export default function useOverlaysState({showAreasProp, showTracksProp, showWaypointsProp}: {
    showAreasProp: boolean | undefined;
    showTracksProp: boolean | undefined;
    showWaypointsProp: boolean | undefined;
}): [MapOverlays, SetState<MapOverlays>] {

    const [state, setState] = useState<MapOverlays>({
        showAreas: true,
        showTracks: true,
        showRoutes: true,
        showPublicTracks: false,
        showWaypoints: true,
        showWaypointLabels: false,
        ...getLocalStorageItem<MapOverlays | {}>('overlays', {})
    });

    useEffect(() => {
        setLocalStorageItem('overlays', state);
    }, [state]);

    const overlays = {
        ...state,
        ...showAreasProp !== undefined && {showAreas: showAreasProp},
        ...showTracksProp !== undefined && {showTracks: showTracksProp},
        ...showWaypointsProp !== undefined && {showWaypoints: showWaypointsProp},
    };

    return [overlays, setState];
}
